import { styles } from '../../common.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as addonFormTypes } from './template.scss';

export const templateLicenseMonthlyAddonsForm = document.createElement('template');

templateLicenseMonthlyAddonsForm.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <style>${addonFormTypes}</style>

  <gz-form-field id='additional-phasr-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-form-field id='additional-easm-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-form-field id='additional-compliance-manager-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <div class='in-trial-text'>
    <gz-form-field id='additional-advanced-threat-security-form-field'>
      <gz-toggle gz-form-input placeholder=''></gz-toggle>
    </gz-form-field>
    <div id='ats-trial-started-text' class='hidden trial-started-text'>
    </div>
  </div>
  <gz-form-field class='pl-5' id='additional-hyper-detect-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-form-field class='pl-5' id='additional-sandbox-analyzer-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <section class='text-form-field-section'>
    <div class='in-trial-text'>
      <gz-form-field id='additional-endpoint-detection-and-response-form-field'>
        <gz-toggle gz-form-input placeholder=''></gz-toggle>
      </gz-form-field>
      <div id='edr-trial-started-text' class='hidden trial-started-text'>
      </div>
    </div>
    <gz-radio-group class='pl-5' id='endpoint-detection-and-response-retention-addons' gz-form-input selectedOption='' hidden disabled>
      <gz-radio id='endpoint-detection-and-response-no-retention-option'></gz-radio>
      <gz-radio class='mt-1' id='endpoint-detection-and-response-90-option'></gz-radio>
      <gz-radio class='mt-1' id='endpoint-detection-and-response-180-option'></gz-radio>
      <gz-radio class='mt-1' id='endpoint-detection-and-response-365-option'></gz-radio>
    </gz-radio-group>
    <gz-text fontSize="12" class="helper-text mb-1" id="additional-edr-text"></gz-text>
  </section>

  <gz-form-field id='additional-extended-detection-and-response-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

    <gz-form-field class='pl-5' id='additional-identity-providers-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
   </gz-form-field>

  <gz-form-field class='pl-5' id='additional-productivity-apps-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-form-field class='pl-5' id='additional-network-sensors-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-form-field class='pl-5' id='additional-cloud-workloads-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <div class="mb-2 subtitle" id='own-use-xdr-sensors-details'>
    <span id='own-use-xdr-sensors-details-text'></span>
     <gz-link type='underline' color='primary' id='own-use-xdr-sensors-details-link'></gz-link>
  </div>

  <gz-form-field id='additional-full-disk-encryption-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-form-field id='additional-patch-management-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-form-field id='additional-integrity-monitor-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-radio-group class='pl-5' id='integrity-monitor-retention-addons' gz-form-input selectedOption='' hidden disabled>
    <gz-radio id='im-retention-7-option'></gz-radio>
    <gz-radio class='mt-1' id='im-retention-90-option'></gz-radio>
    <gz-radio class='mt-1' id='im-retention-180-option'></gz-radio>
    <gz-radio class='mt-1' id='im-retention-365-option'></gz-radio>
  </gz-radio-group>

  <gz-form-field id='additional-email-security-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-form-field id='additional-mobile-security-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-form-field id='additional-security-for-exchange-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-form-field id='additional-security-for-virtualized-environments-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>

  <gz-form-field id='additional-container-security-form-field'>
    <gz-toggle gz-form-input placeholder=''></gz-toggle>
  </gz-form-field>
`;
